var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shape-46",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    transform: "translate(46 46) rotate(180)",
    fill: "#f2f3f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxIcon);
export default __webpack_public_path__ + "static/media/iconBox_icon.a25af69591b0ff112f99fb7d2efe41d3.svg";
export { ForwardRef as ReactComponent };